module.exports = "<div ng-if=\"eventAlertsCtrl.alert\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n  <div class=\"ibox float-e-margins\">\n    <div class=\"alert alert-warning\" role=\"alert\">\n      <span class=\"glyphicon glyphicon-exclamation-sign\"\n        aria-hidden=\"true\"></span>\n      <span class=\"sr-only\">Warning:</span>\n      Please add a webinar to the event.\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/eventManager/event/alerts/template.html
// module id = 1798
// module chunks = 0